export default __webpack_public_path__ + "static/media/add.b126bd07.svg";